/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { PureComponent } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import classnames from 'classnames';
import Notes from './Notes';
import HistoricalCharts from './HistoricalCharts';
import HistoricalDataTableModal from './HistoricalDataTableModal';
import NocHistory from './NocHistory';
import { ReactComponent as ExcelSvg } from '../Res/excelExport.svg';
import { ReactComponent as PdfSvg } from '../Res/pdfExport.svg';
import { getPermissionForComponent } from '../utils/permissionsUtils';

class AddNotesList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'notes',
      showHistoricalTable: false,
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  openTable = () => this.setState({ showHistoricalTable: true });
  closeTable = () => this.setState({ showHistoricalTable: false });

  render() {
    const {
      onConfirm,
      isOpen,
      onCancel,
      boxNotes,
      handleChangePagination,
      user,
      onEditNote,
      onDownload,
      onDeleteNote,
      boxDetails,
      onDeleteNoteRecording,
      onDownloadNotes,
      notesSelectedTab,
      ...noteProps
    } = this.props;
    const { activeTab, showHistoricalTable } = this.state;

    const deviceHistoricalDataPermission = getPermissionForComponent('deviceHistoricalData', user.permissionsGroup);
    // const nocHistoryPermission = getPermissionForComponent('epikEngineering', user.permissionsGroup);

    return (
      <Modal isOpen={isOpen} toggle={onCancel} className="create-box-modal">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'notes' })}
              onClick={() => this.toggleTab('notes')}
              style={{ cursor: 'pointer' }}
            >
              Notes
            </NavLink>
          </NavItem>
          { deviceHistoricalDataPermission && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'historical' })}
              onClick={() => this.toggleTab('historical')}
              style={{ cursor: 'pointer' }}
            >
              Historical Data
            </NavLink>
          </NavItem>
          )}
          { user?.epikEngineering && (
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === 'noc' })}
              onClick={() => this.toggleTab('noc')}
              style={{ cursor: 'pointer' }}
            >
              Escalations Log
            </NavLink>
          </NavItem>
          )}
        </Nav>

        {activeTab === 'notes' ? (
          <>
            {notesSelectedTab === '1' || notesSelectedTab === '2' ? (
              <Row style={{ padding: '0 15px' }}>
                <Col
                  sm={6}
                  style={{ paddingRight: 'initial', paddingLeft: 'initial' }}
                >
                  <ModalHeader style={{ padding: '1.07rem 1rem' }}>
                    Notes for Edge Device : {boxDetails.serialNumber}
                  </ModalHeader>
                </Col>
                <Col
                  sm={6}
                  style={{ paddingRight: 'initial', paddingLeft: 'initial' }}
                >
                  <ModalHeader className="export-notes">
                    <ExcelSvg
                      className="mr-3  mb-2 cursor-pointer"
                      onClick={() => onDownloadNotes('xlsx')}
                      width={40}
                      height={40}
                    />
                    <PdfSvg
                      className="ml-3  mb-2 cursor-pointer"
                      onClick={() => onDownloadNotes('pdf')}
                      width={40}
                      height={40}
                    />
                  </ModalHeader>
                </Col>
              </Row>
            ) : (
              <ModalHeader>
                Notes for Edge Device : {boxDetails?.serialNumber}
              </ModalHeader>
            )}

            <ModalBody style={{ minHeight: 650 }}>
              <Notes
                onEditNote={onEditNote}
                onDownload={onDownload}
                onDeleteNote={onDeleteNote}
                onDeleteNoteRecording={onDeleteNoteRecording}
                user={user}
                handleChangePagination={handleChangePagination}
                boxNotes={boxNotes}
                boxDetails={boxDetails}
                onConfirm={onConfirm}
              />
            </ModalBody>
          </>
        ) : activeTab === 'historical' ? (
            deviceHistoricalDataPermission && (
              <>
                <ModalHeader>
                  Historical Data for Edge Device: {boxDetails?.serialNumber}
                </ModalHeader>
                <ModalBody style={{ minHeight: 650 }}>
                  <HistoricalCharts deviceId={boxDetails?.serialNumber} />
                  <HistoricalDataTableModal deviceId={boxDetails?.serialNumber}/>
                </ModalBody>
              </>
            )
        ) : activeTab === 'noc' && user?.epikEngineering ? (
          <>
            <ModalHeader>
              NOC History for Edge Device: {boxDetails?.serialNumber}
            </ModalHeader>
            <ModalBody style={{ minHeight: 650 }}>
              <NocHistory boxDetails={boxDetails} />
            </ModalBody>
          </>
        ) : null}

        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddNotesList;

